import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Add } from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { appStyles } from "../App.styles";
import { ButtonSG, DeleteConfirmButtonSG } from "../components";
/** Brand Voice Header */
export const BrandVoiceHeader = ({ disabled, handleDeleteConfirmClick, handleNewClick }) => {
    const { t } = useTranslation();
    return (_jsx(Box, Object.assign({ sx: {
            backgroundColor: 'white.main',
            padding: '0',
            zIndex: '2',
        } }, { children: _jsxs(Grid
        // Project flex container
        , Object.assign({ 
            // Project flex container
            container: true, columnSpacing: 1, sx: { padding: '0', alignItems: 'center' } }, { children: [_jsx(Grid
                // Project title flex item
                , Object.assign({ 
                    // Project title flex item
                    item: true, xs: true, sx: {
                        overflow: 'hidden',
                        display: 'flex',
                        width: '1px',
                    } }, { children: _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text28), { textOverflow: 'ellipsis', overflow: 'hidden', width: 'calc(100%)', whiteSpace: 'nowrap' }), component: "h1" }, { children: t('Brand Voice') })) })), _jsx(Grid
                // Project buttons flex item
                , Object.assign({ 
                    // Project buttons flex item
                    item: true }, { children: _jsx(ButtonSG
                    // New button
                    , Object.assign({ 
                        // New button
                        variant: "contained", onClick: handleNewClick, startIcon: _jsx(Add, {}) }, { children: t('New') })) })), _jsx(Grid, Object.assign({ item: true }, { children: _jsx(DeleteConfirmButtonSG, { disabled: disabled, handleDeleteConfirmClick: handleDeleteConfirmClick }) }))] })) })));
};
